import { useGetKeyQuery } from ".";
import { useGetDeptFromStore, useGetUserFromStore } from "../Hooks/get-user";
import { useAppDispatch, useAppSelector } from "../Hooks/typed-hooks";
import {
  pubKey,
  selectPaystackPublicKey,
  setPayStackPublicKey,
  updatePKey,
} from "../slices/p-key.slice";

// Get pub
export const useGetPubKey = () => {
  const stripePubKey: string = useAppSelector(pubKey);
  const paystackPubKey = useAppSelector(selectPaystackPublicKey);

  return { stripePubKey, paystackPubKey };
};

export const useSetPaymentPublicKeys = () => {
  const { accessToken: deptToken } = useGetDeptFromStore();
  const { accessToken: userToken } = useGetUserFromStore();
  const dispatch = useAppDispatch();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { data, isLoading, error } = useGetKeyQuery({
    accessToken: deptToken || userToken,
  });

  if (data) {
    dispatch(updatePKey(data?.data?.stripePk));
    dispatch(setPayStackPublicKey(data?.data?.paystackPk));
  }
};
